export function smoothScroll() {
  // ページロード時にURLハッシュがある場合の処理
  handleInitialHash();
  
  // アンカーリンクにスムーススクロールを適用
  const anchorLinks = document.querySelectorAll('a[href^="#"]');
  
  anchorLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      
      // href属性からターゲットIDを取得
      const targetId = link.getAttribute('href');
      const targetElement = document.querySelector(targetId);
      
      if (targetElement) {
        // 強化されたスムーススクロール実行
        performRobustScroll(targetElement);
      }
    });
  });
}

// ページロード時のハッシュ処理
function handleInitialHash() {
  // DOMContentLoadedイベントでハッシュをチェック
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      checkAndScrollToHash();
    });
  } else {
    // 既にDOMが読み込まれている場合
    checkAndScrollToHash();
  }
}

// URLハッシュをチェックしてスクロール
function checkAndScrollToHash() {
  const hash = window.location.hash;
  if (hash) {
    const targetElement = document.querySelector(hash);
    if (targetElement) {
      // 少し遅延させてページの読み込みを待つ
      setTimeout(() => {
        performRobustScroll(targetElement);
      }, 100);
    }
  }
}

// オプション付きスムーススクロール（外部から呼び出し可能）
export function performRobustScroll(targetElement, options = {}) {
  // デフォルトオプション
  const defaultOptions = {
    useHeaderOffset: true,
    additionalOffset: 0
  };
  
  const config = { ...defaultOptions, ...options };
  
  // ヘッダーオフセットの計算
  let headerOffset = 0;
  if (config.useHeaderOffset) {
    const header = document.querySelector('.l-header') || document.querySelector('.l-header--recruitment');
    const headerHeight = header ? header.offsetHeight : 80;
    headerOffset = headerHeight + config.additionalOffset;
  }
  
  // 確実にスクロールが完了するカスタム実装
  const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - headerOffset;
  const startPosition = window.pageYOffset;
  const distance = targetPosition - startPosition;
  
  // 短い距離なら瞬間移動
  if (Math.abs(distance) < 100) {
    window.scrollTo(0, targetPosition);
    return;
  }
  
  // カスタムスムーススクロール（確実に到達）
  let currentTime = 0;
  const duration = 800; // 固定時間
  const increment = 20; // 20msごとに更新
  
  function animateScroll() {
    currentTime += increment;
    const progress = Math.min(currentTime / duration, 1);
    
    // イージング: easeInOutCubic
    const ease = progress < 0.5 
      ? 4 * progress * progress * progress 
      : 1 - Math.pow(-2 * progress + 2, 3) / 2;
    
    const newPosition = startPosition + (distance * ease);
    window.scrollTo(0, newPosition);
    
    if (progress < 1) {
      setTimeout(animateScroll, increment);
    } else {
      // 最終調整で確実に目標位置へ
      window.scrollTo(0, targetPosition);
    }
  }
  
  animateScroll();
} 